import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {RecordMigration} from "../utils/migrateRecord";
import {MigrateRecordCommand} from "./migrateRecord.command";

// Applies a dependency-ordered batch of record migrations (from
// planRecordMigration) as a single history entry, so one undo reverts the whole
// cascade. Each entry reuses MigrateRecordCommand's additive insert; entries
// already present on Current are no-ops.
export class MigrateWithDependenciesCommand extends CommandBase {
    migrations: RecordMigration[];

    constructor(migrations: RecordMigration[]) {
        super();
        this.migrations = migrations;
    }

    execute(data: RemoteConstantsModel): boolean {
        let mutated = false;
        for (const migration of this.migrations) {
            if (new MigrateRecordCommand(migration).execute(data)) mutated = true;
        }
        return mutated;
    }
}
